import { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"

export default css`
  text-align: center;

  ${breakpoint("sm")`
        text-align: left;
    `}

  *:is(h2,h3, strong) {
    font-weight: 700;
    color: inherit;
    font-size: clamp(2.5rem, 6vmin, 58px);
    line-height: 1.1;

    + * {
      margin-top: 1em;
    }
  }

  h5 {
    font-weight: 600;
    font-size: calc(1em + 0.4vmax);
  }

  p {
    font-size: calc(0.9em + 0.35vmax);

    > a {
      display: inline-flex;
      white-space: nowrap;
      border-color: ${(props) => props.theme.colors.primary};
      background-color: ${(props) => props.theme.colors.primary};
      font-weight: 600;
      font-size: 16px;
      min-height: 48px;
      line-height: 48px;
      appearance: none;
      cursor: pointer;
      border: 1px transparent solid;
      border-radius: 48px;
      padding: 0 1.5em;
      align-items: center;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      color: ${(props) => props.theme.colors.textColor};

      &:active,
      &:focus {
        background-color: ${(props) => props.theme.colors.orange};
        color: ${(props) => props.theme.colors.white};
      }

      @media (hover: hover) {
        &:hover {
          background-color: ${(props) => props.theme.colors.white};
        }
      }
    }
  }

  > a {
    margin-top: 1em;
    display: inline-flex;
  }

  .btn {
    margin-top: 1em;
  }
`
